"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _theme = _interopRequireDefault(require("../../Theme/lib/AirasiaClassic/theme"));

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize"];

var Flatbed = function Flatbed(props) {
  var fontsize = props.fontsize,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize
  }, theme),
      sizeStyles = _parseStyles.sizeStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 39 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd" // eslint-disable-next-line max-len
    ,
    d: "M0.5 30H2.5C3.60457 30 4.5 30.8954 4.5 32V54L34.5 54V32C34.5 30.8954 35.3954 30 36.5 30C37.6046 30 38.5 30.8954 38.5 32V54V56C38.5 57.1046 37.6046 58 36.5 58L0.5 58V56V54V30Z",
    fill: _theme.default.colors.greyLight
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.5",
    y: "8",
    width: "26",
    height: "31",
    rx: "4",
    fill: _theme.default.colors.greyDarker
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.5",
    y: "52",
    width: "14",
    height: "26",
    rx: "4",
    transform: "rotate(-90 6.5 52)",
    fill: _theme.default.colors.primary
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.5",
    y: "9",
    width: "9",
    height: "26",
    rx: "2",
    transform: "rotate(-90 6.5 9)",
    fill: _theme.default.colors.primaryDark
  })));
};

Flatbed.propTypes = _inline_svg2.default.propTypes;
Flatbed.defaultProps = _inline_svg2.default.defaultProps;
var _default = Flatbed;
exports.default = _default;